module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/内蔵フロントカメラ.9f6e75d7.png";